import { Artist, AudioFeature, Track } from "../../spotify/spotify";

export const sanitizeSongName = (name: string): string => name.includes('(feat') ? name.substring(0, name.indexOf('(feat')) : name;

const audioFeatureToVector = (feature: AudioFeature): number[] => [
    feature.acousticness, feature.danceability, feature.energy, feature.instrumentalness, feature.liveness,
    feature.loudness / -100, feature.speechiness, feature.valence, feature.mode / 2 + 0.25
].map(x => x * 100);

const cosineSimilarity = (A: number[], B: number[]): number => {
    let dotprod = 0;
    let mA = 0;
    let mB = 0;
    for (let i = 0; i < A.length; i++) {
        dotprod += (A[i] * B[i]);
        mA += (A[i] * A[i]);
        mB += (B[i] * B[i]);
    }
    mA = Math.sqrt(mA);
    mB = Math.sqrt(mB);
    const similarity = (dotprod) / ((mA) * (mB));
    console.log(`[${A.map(x => Math.floor(x*1000) / 1000).join('\t')}]\n[${B.map(x => Math.floor(x*1000) / 1000).join('\t')}]\n = ${similarity}`);
    return similarity;
}

export const getSimilarSongs = (allSongs: (Track & {features: AudioFeature})[], targetSong: AudioFeature, minSimilarity: number): Track[] => {
    const targetVector = audioFeatureToVector(targetSong);
    let similarSongs: Track[] = [];
    allSongs.forEach(song => {
        const similarity = cosineSimilarity(targetVector, audioFeatureToVector(song.features));
        if (similarity >= minSimilarity && song.id !== targetSong.id) {
            similarSongs.push(song as Track);
        }
    })
    return similarSongs;
}

export const getSimilarSongsPercent = (allSongs: (Track & {features: AudioFeature})[], targetSong: AudioFeature, minSimilarity: number): Track[] => {
    const targetVector = audioFeatureToVector(targetSong);
    console.log(`[${targetVector.map(x => Math.floor(x*1000) / 1000).join('\t')}]`);
    console.log(`[${targetVector.map(x => x * minSimilarity).map(x => Math.floor(x*1000) / 1000).join('\t')}]`);
    console.log(`[${targetVector.map(x => x * (1 + (1 - minSimilarity))).map(x => Math.floor(x*1000) / 1000).join('\t')}]`);
    console.log('---------------------------------------------------------');
    //let similarSongs: Track[] = [];
    let similarSongs: (Track & {features: AudioFeature})[] = [];
    allSongs.forEach(song => {
        const songFeature = audioFeatureToVector(song.features); // .53 .89
        // option 1: all features must be within range
        //const allFeaturesSimilar = (targetVector.map((v, i) => [v, songFeature[i]])).every(feature => (Math.abs(feature[1] - feature[0]) / Math.abs(feature[0])) < (1 - minSimilarity) );
        //if (allFeaturesSimilar && song.id !== targetSong.id) {

        // option 2: certain amount of features must be within range
        //const numFeaturesSimilar = (targetVector.map((v, i) => [v, songFeature[i]])).filter(feature => (Math.abs(feature[1] - feature[0]) / Math.abs(feature[0])) < (1 - minSimilarity) ).length;
        //console.log(`[${songFeature.map(x => Math.floor(x*1000) / 1000).join('\t')}]`);
        //console.log(`${numFeaturesSimilar} / ${targetVector.length}`)
        //if (numFeaturesSimilar === targetVector.length && song.id !== targetSong.id) {
        //if (numFeaturesSimilar >= Math.floor(targetVector.length * (2 / 4)) && song.id !== targetSong.id) {

        // option 3: average similarity across all features is within range
        const avgSimilarity = (targetVector.map((v, i) => [v, songFeature[i]])).map(feature => (Math.abs(feature[1] - feature[0]) / Math.abs(feature[0]))).reduce((acc, curr) => acc + curr) / songFeature.length;
        console.log(avgSimilarity);
        if (avgSimilarity >= minSimilarity) {
            similarSongs.push(song);
            console.log(song.name);
            //console.log((targetVector.map((v, i) => [v, songFeature[i]])).map(feature => (Math.abs(feature[1] - feature[0]) / Math.abs(feature[0])) < (1 - minSimilarity) ));
        }
    });
    similarSongs.sort((a, b) => cosineSimilarity(targetVector, audioFeatureToVector(b.features)) - cosineSimilarity(targetVector, audioFeatureToVector(a.features)));
    return similarSongs;
}

export const getGenreCounts = (artists: Artist[]): ({genre: string, count: number})[]  => {
    let genreHist: Record<string, number> = {};
    artists.forEach(artist => {
        const genres = artist.genres;
        genres.forEach(g => genreHist[g] = (genreHist[g] || 0) + 1);
    });
    let genresSorted = Object.entries(genreHist).sort((a, b) => b[1] - a[1]);
    return genresSorted.map(([genre, count]) => ({genre, count}));
}

export const getTopGenres = (artists: Artist[]): string[] => {
    let genreHist: Record<string, number> = {};
    artists.forEach(artist => {
        const genres = artist.genres;
        genres.forEach(g => genreHist[g] = (genreHist[g] || 0) + 1);
    });
    let genresSorted = Object.entries(genreHist).sort((a, b) => b[1] - a[1]);
    return genresSorted.slice(0, Math.min(genresSorted.length, 5)).map(a => a[0]);
}

export const getTopGenresTracks = (songs: Track[]): string[] => {
    let genreHist: Record<string, number> = {};
    songs.forEach(song => {
        const genres = song.artists.map(a => a.genres).flat();
        console.log(genres);
        genres.forEach(g => genreHist[g] = (genreHist[g] || 0) + 1);
    });
    let genresSorted = Object.entries(genreHist).sort((a, b) => b[1] - a[1]);
    return genresSorted.slice(0, Math.min(genresSorted.length, 10)).map(a => a[0]);
}

